<template>
  <a-spin :spinning="confirmLoading">
    <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
      <a-form :form="form">
        <a-form-item
          v-show="false"
          label="id"
        >
          <a-input
            v-decorator="['id']"
          />
        </a-form-item>
        <a-form-item
          label="标题"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
          <a-input
            :disabled="showable"
            v-decorator="[
              'headline',
              {rules: [{ required: true, message: '请输入文章名' }]}
            ]"
            placeholder="请输入标题" />
        </a-form-item>
        <a-form-item
          label="附件"
          :labelCol="{lg: {span: 7}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
        >
          <upload
            :url="url"
            :fileListTemp="file"
            @updateFileList="(data) => changeList(data,'file')"
            v-decorator="['file']"
          />
        </a-form-item>
        <a-form-item
          :wrapperCol="{ span: 24 }"
          style="text-align: center"
        >
          <a-button :loading="confirmLoading" :disabled="showable" htmlType="submit" type="primary" @click="handleOk">发布</a-button>
          <a-button key="cancel" @click="handleCancel" style="margin-left: 8px">返回</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>
import { save, getObj, update } from '@/api/sys/file'
import pick from 'lodash.pick'
import Upload from '@/views/modules/sx/uploadDragger/Upload'

export default {
  name: 'FileAddOrUpdate',
  components: {
    Upload
  },
  data () {
    return {
      content: '',
      confirmLoading: false,
      addable: false,
      visible: false,
      editable: false,
      showable: false,
      file: [],
      url: 'api/storage/upload',
      type: 'add',
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      // form
      form: this.$form.createForm(this)

    }
  },
  activated  () {
    const noticeId = this.$route.query.id
    const type = this.$route.query.type
    this.edit(noticeId, type)
  },
  methods: {
    changeList (data, str) {
      this.file = data
      this.form.setFieldsValue({ file: JSON.stringify(data) })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onChange (e) {
    },
    // 获取信息
    edit (id, type) {
      this.visible = true
      if (type && type === 'add') {
        this.addable = true
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = false
        getObj(id).then(res => {
          const record = res.data
          if (record.file) {
            this.file = JSON.parse(record.file)
          }
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, [
              'id',
              'headline'
            ]))
          })
        })
      } else {
        resetFields()
      }
    },

    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'edit') {
              this.confirmLoading = false
              await update(values).then(() => {
                this.confirmLoading = false
                this.$message.success('修改成功', 1).then(() => {
                  this.$router.push({ name: 'file' })
                })
              })
            } else {
              await save(values).then(() => {
                this.confirmLoading = false
                this.$message.success('保存成功', 1).then(() => {
                  this.$router.push({ name: 'file' })
                })
              })
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.visible = false
            }, 1500)
          } catch (e) {
            this.$message.error(e.msg)
            this.confirmLoading = false
          }
        }
      })
    },
    handleCancel () {
      this.$router.push({ name: 'file' })
    }
  }
}
</script>
